import { motion } from "framer-motion";
import { Check, ArrowLeft } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal, Eyebrow } from "@/components/Reveal";
import PhoneMockup from "@/components/PhoneMockup";

export default function ProductIntro({ onJoin }) {
  const { t, isRtl } = useLanguage();

  return (
    <section id="tafakar" data-testid="product-intro-section" className="relative py-20 sm:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <PhoneMockup />
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal>
            <Eyebrow>{t.intro.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-4 font-display font-bold tracking-tight leading-snug text-2xl sm:text-3xl text-slate-900" data-testid="intro-lead">
              {t.intro.lead}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-slate-600 max-w-2xl">{t.intro.p1}</p>
          </Reveal>
          <Reveal delay={0.4}>
            <div className="mt-8 flex flex-wrap gap-3">
              {t.intro.chips.map((chip) => (
                <span key={chip} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-slate-200 text-sm font-semibold text-slate-700 shadow-sm">
                  <Check size={14} className="text-lime-600" />
                  {chip}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.5}>
            <motion.button
              data-testid="intro-join-button"
              onClick={onJoin}
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.97 }}
              className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-slate-900 text-white font-bold text-sm hover:bg-lime-500 hover:text-slate-900 transition-colors"
            >
              {t.intro.cta}
              <ArrowLeft size={16} className={isRtl ? "" : "rotate-180"} />
            </motion.button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
